import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import reinstatementService from '../../../../../services/Internal/Reinstatement/VF/vfReinstatement.service';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Issues from '../../../../Shared/Card/Issues';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import RedStar from '../../../../Shared/GenericComponents/RedStar';

function AcknowledgementPage() {
    const [hasLoaded, setHasLoaded] = useState(false)
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Surveying Firm Reinstatement",
            isIndividual: false,
            entityId: 0,
            applicationDate: "",
            currentSection: "Acknowledgement"
        }
    );
    const push = useNavigate();
    const { StringType } = Schema.Types;
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const routes = useSelector(x => x.currentRoutes);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const sectionId = 9; // Revisit
    const [formModel, setFormModel] = useState({})
    useEffect(() => {
        reinstatementService.vfGetSection(reinstatementId, sectionId).then((response) => {
            setFormModel(response.data);
            setIsComplete(response.data.staffReviewComplete);
            reinstatementService.getFirmReinstatement(reinstatementId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            });
        })
    }, [])
    const model = Schema.Model({
        electronicSignature: StringType().isRequired('This field is required.')
    });

    const formSubmit = (validation, event) => {
            reinstatementService.vfPostSection(reinstatementId, sectionId, formModel.electronicSignature).then((response) => {
                reinstatementService.vfMarkSectionComplete(reinstatementId, sectionId, isComplete).then((data) => {
                    if (response.data.id && data.data.id) {
                        nextSectionNavigation();
                    }

                })
            })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }

    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                {hasLoaded ?
                    <Form readOnly={!isUserEditable} model={model} fluid formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header><h6>Requirements/Information/Acknowledgement</h6></Card.Header>
                                    <Card.Body>
                                        <p>
                                            Fields marked with an asterisk * are required.
                                        </p>
                                        <br />
                                        <p>
                                            I certify that I have read the contents of this application and to the best of my knowledge, information and belief the
                                            statements and information in this application are true and correct in substance and effect and are made in good faith. I
                                            have not omitted any information requested in this application. I am aware that such an omission or untrue response
                                            may constitute fraud, deceit, material misstatement, perjury or the giving of false or forged evidence under Louisiana
                                            Revised Statutes 37:698 and 37:700.
                                        </p>
                                        <hr />
                                        <Row>
                                            <Col sm={4}>
                                                <h5>Electronic Signature of Applicant:<RedStar /></h5>
                                                <span>(Type full name)</span>
                                            </Col>
                                            <Col sm={8}><Form.Control name="electronicSignature" /></Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={2} sectionId={formModel.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isReadOnly={!isUserEditable}
                            nextSectionCallback={nextSectionNavigation}
                            isUserEditable={isUserEditable}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete}
                            backToSectionLink="/internal/vfReinstatement/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default AcknowledgementPage